import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function HowItWorks() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/site-content").then(({ data }) => setContent(data?.how_it_works)).catch(() => {});
  }, []);

  const steps = content?.steps || [];

  return (
    <div data-testid="how-it-works-page">
      <section className="border-b border-zinc-200">
        <div className="app-container py-24 md:py-32">
          <p className="overline mb-6">How it works</p>
          <h1 className="text-5xl md:text-7xl font-black tracking-tighter leading-[0.95] max-w-4xl" style={{ fontFamily: "'Outfit', sans-serif" }}>
            No slide decks. No six-month roadmaps.
          </h1>
          <p className="text-lg text-zinc-600 mt-6 max-w-2xl">
            We build small, useful things fast — then we stop. Here's the shape of a typical Appistry engagement.
          </p>
        </div>
      </section>

      <section>
        <div className="app-container py-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-0 border-t border-zinc-200">
            {steps.map((s, i) => (
              <div key={s.title} className="md:col-span-6 lg:col-span-3 p-10 border-r border-b border-zinc-200 bg-white last:border-r-0" data-testid={`how-step-${i}`}>
                <div className="h-12 w-12 border border-zinc-950 flex items-center justify-center font-mono text-base font-bold mb-8">
                  0{i + 1}
                </div>
                <h2 className="text-2xl font-semibold tracking-tight mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>{s.title}</h2>
                <p className="text-zinc-600 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-zinc-950 text-white">
        <div className="app-container py-24 text-center">
          <h2 className="text-4xl md:text-5xl font-black tracking-tighter mb-6" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Ready to start at step 1?
          </h2>
          <Link to="/contact" className="btn-signal" data-testid="hiw-cta">
            See how we can help <ArrowRight size={16} weight="bold" />
          </Link>
        </div>
      </section>
    </div>
  );
}
